module.exports = __webpack_public_path__ + "img/9788949120638.78945e10.jpg";